import { get } from "lodash";
import { DELTA_END_TYPES, PERIOD_UNITS } from "utils/constants";

export const buildQuoteValidityFormState = (stored) => {
  const empty = {
    type: null,
    value: null,
    unit: null,
    limitEndOfYear: false,
  };

  if (stored && typeof stored === "object") {
    const type = get(stored, "type") || null;
    if (type === DELTA_END_TYPES.ADD_PERIOD) {
      return {
        type,
        value: get(stored, "value") ?? get(stored, "days") ?? null,
        unit: get(stored, "unit") || PERIOD_UNITS.DAYS,
        limitEndOfYear: !!get(stored, "limitEndOfYear"),
      };
    }
    if (type === DELTA_END_TYPES.END_OF_YEAR) {
      return { ...empty, type };
    }
    return empty;
  }

  if (stored === 0) {
    return { ...empty, type: DELTA_END_TYPES.END_OF_YEAR };
  }
  if (stored > 0) {
    return {
      type: DELTA_END_TYPES.ADD_PERIOD,
      value: stored,
      unit: PERIOD_UNITS.DAYS,
      limitEndOfYear: false,
    };
  }

  return empty;
};

export const serializeQuoteValidityConfig = (formState) => {
  const type = get(formState, "type");

  if (type === DELTA_END_TYPES.END_OF_YEAR) {
    return { type: DELTA_END_TYPES.END_OF_YEAR };
  }

  if (type === DELTA_END_TYPES.ADD_PERIOD) {
    const value = Number(get(formState, "value"));
    if (!Number.isFinite(value)) return null;
    return {
      type: DELTA_END_TYPES.ADD_PERIOD,
      value,
      unit: get(formState, "unit") || PERIOD_UNITS.DAYS,
      limitEndOfYear: !!get(formState, "limitEndOfYear"),
    };
  }

  return null;
};
